import { MatchInterviewType } from '../match/match-interview-type';

export const INTERVIEW_ACTION_TYPES = [
  'proposes_dates',
  'confirms_date',
  'declines_no_date',
  'reschedules_with_date',
  'reschedules_no_date',
  'cancels',
  'unclear',
] as const;

export type InterviewActionType = (typeof INTERVIEW_ACTION_TYPES)[number];

export interface InterviewActionDate {
  date: string;
  time: string | null;
  timeStated: boolean;
}

/**
 * A single interview scheduling decision extracted from an employer email by the
 * `PROMPT_AI_EMAIL_SUMMARIZATION` Bedrock call, one per interview the email discusses. Feeds IA2, which
 * applies the corresponding CRM changes.
 */
export interface InterviewAction {
  matchId: string;
  interviewId: string | null;
  interviewType?: MatchInterviewType | null;
  action: InterviewActionType;
  dates: InterviewActionDate[];
  confidence: number;
  ambiguousInterview: boolean;
  cancellationReason: string | null;
  appliedAt: string | null;
  appliedByEmployeeId?: string | null;
  appliedInterviewIds?: string[];
  dismissedAt?: string | null;
  dismissedByEmployeeId?: string | null;
}

export enum InterviewActionState {
  Open = 'open',
  Applied = 'applied',
  Dismissed = 'dismissed',
  Expired = 'expired',
  NeedsManualHandling = 'needs_manual_handling',
}
